import { render, staticRenderFns } from "./reset-password2.vue?vue&type=template&id=56098b94"
import script from "./reset-password2.vue?vue&type=script&lang=js"
export * from "./reset-password2.vue?vue&type=script&lang=js"
import style0 from "./reset-password2.vue?vue&type=style&index=0&id=56098b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports